import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-live-tracker',
  templateUrl: './live-tracker.component.html',
  styleUrls: ['./live-tracker.component.scss']
})
export class LiveTrackerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
